import { render, staticRenderFns } from "./SocialStreamPost.vue?vue&type=template&id=656f7e1a"
import script from "./SocialStreamPost.vue?vue&type=script&lang=ts"
export * from "./SocialStreamPost.vue?vue&type=script&lang=ts"
import style0 from "./SocialStreamPost.vue?vue&type=style&index=0&id=656f7e1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports